import { CSSObject } from '@mui/material';

import type { Theme } from '../../themes/themes';

export const createSelectFieldTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          ...(theme.typography.button as CSSObject),

          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.action.focus,
          },

          '& .MuiSelect-icon': {
            padding: theme.spacing(5),
            marginRight: 0,
            marginTop: 'auto',
            marginBottom: 'auto',
            top: '2px',
            bottom: '2px',
            right: '0',
            pointerEvents: 'auto',
            cursor: 'pointer',
          },
          '& .MuiSelect-icon + .MuiInputAdornment-positionStart': {
            marginRight: theme.spacing(9),
          },
        },
        input: {
          '.Mui-locked &': {
            color: theme.palette.secondary.darker,
            WebkitTextFillColor: theme.palette.secondary.darker,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          ...(theme.typography.button as CSSObject),

          top: '2px',
          [theme.breakpoints.up('lg')]: {
            top: '0',
          },

          '&.Mui-locked': {
            color: theme.palette.secondary.darker,
          },

          '&.Mui-focused': {
            color: theme.palette.action.focus,
            top: '2px',

            [theme.breakpoints.up('lg')]: {
              top: '0',
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          '& ~ .MuiInputAdornment-positionEnd': {
            marginRight: theme.spacing(10),
          },
          '& ~ .MuiIconButton-root': {
            color: theme.palette.button.secondary.colorActive,
            fontSize: { xs: 5, md: 6, lg: 6 },

            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
        },
        icon: {
          marginRight: theme.spacing(5),

          '.Mui-locked &': {
            color: theme.palette.secondary.darker,
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          marginTop: theme.spacing(4),
          borderRadius: theme.spacing(4),
          borderStyle: 'solid',
          borderWidth: '1px',
          borderColor: theme.palette.divider,

          '&.MuiPaper-root': {
            boxShadow: '0px 2px 3px rgba(86, 86, 86, 0.1)',
            maxHeight: '80vh',
          },
        },
      },
    },
  },
});
